'use client'

import { CxpExtendedContactForm } from '@/components/common/cxp/cxp-extended-contact-form'
import { ContactFormSection } from '@/types/coolxprint2'
import { useTranslations } from 'next-intl'

const DEFAULT_SOLUTION_OPTIONS_IDS = [
  'fast_uniform',
  'custom_production',
  'coolgift',
]

const DEFAULT_QUANTITY_OPTIONS_IDS = [
  'range_1_5',
  'range_6_19',
  'range_20_50',
  'range_51_100',
  'range_101_500',
  'range_501_1000',
  'above_1000',
]

interface FormOnlyContentProps {
  data?: ContactFormSection
}

export function FormOnlyContent({ data }: FormOnlyContentProps) {
  const t = useTranslations('cxp.home.contact_form')

  const formHeading = data?.form_heading || t('form_heading')
  const formBadgeText = data?.form_badge_text || t('form_badge_text')

  const solutionOptions = data?.solution_options?.length
    ? data.solution_options.sort((a, b) => a.order - b.order)
    : DEFAULT_SOLUTION_OPTIONS_IDS.map((id, index) => ({
        value: id,
        label: t(`solution_options.${id}`),
        order: index,
      }))

  const quantityOptions = data?.quantity_options?.length
    ? data.quantity_options.sort((a, b) => a.order - b.order)
    : DEFAULT_QUANTITY_OPTIONS_IDS.map((id, index) => ({
        value: id,
        label: t(`quantity_options.${id}`),
        order: index,
      }))

  return (
    <CxpExtendedContactForm
      solutionOptions={solutionOptions}
      quantityOptions={quantityOptions}
      formHeading={formHeading}
      formBadgeText={formBadgeText}
    />
  )
}
